export enum Types {
    DEFAULT = 0,
    SELECTABLE = 1, 
    DEFAULTPRIMARY = 2, 
}
